import { RadioButton } from "components/atoms/radio/radio";
import { InfoIcon } from "components/icons/info";
import React from "react";
import { colors } from "styles/constants/colors";
import {
  ClashesText,
  ClashesWrapper,
  DateClassText,
  RequiredClassText,
  RequiredClassWrapper,
  SlotCardWrapper,
  SlotInformationWrapper,
  SlotSchedule,
  SlotTitle,
  SlotScheduleWrapper,
  SlotStartDateAndSeatContainer,
  StyledChip,
  TeacherDetailWrapper,
  TeacherImage,
  TeacherName
} from "./slot-card.styles";
import {
  ISlotCardProps,
  ISlotSelectionUnavailableFeatureValue
} from "./slot-card.types";
import { getIndonesianTimezone, noop } from "utils/utils";
import { GuruJuaraBadge } from "components/kelas-live/assets/guru-juara-badge";
import DefaultPhotoProfile from "public/assets/home/default-user-profile.png";
import { useFeature } from "@growthbook/growthbook-react";
import { GrowthbookFeatures } from "components/growthbook/growthbook.types";
import { format } from "date-fns";

export const renderAvailableSeatsChip = (
  seatsLeft: number,
  isSelected?: boolean
) => {
  const props = {
    color: "",
    backgroundColor: ""
  };

  if (isSelected) {
    props.color = colors.brand[500];
    props.backgroundColor = colors.blue[100];
  } else if (seatsLeft > 10) {
    props.color = colors.green[800];
    props.backgroundColor = colors.green[100];
  } else if (seatsLeft > 5) {
    props.color = colors.orange[300];
    props.backgroundColor = colors.yellow[100];
  } else if (seatsLeft >= 1) {
    props.color = colors.magenta[400];
    props.backgroundColor = colors.magenta[50];
  } else {
    props.color = colors.neutral[700];
    props.backgroundColor = colors.neutral[100];
  }

  return <StyledChip {...props}>Sisa {seatsLeft} Kursi</StyledChip>;
};

export const renderClassStatusChip = (
  slotSchedule: string,
  isSelected?: boolean
) => {
  const props = {
    color: colors.green[800],
    backgroundColor: colors.green[200]
  };
  let text = "Kelas sudah dimulai";

  const today = new Date();
  const startDate = new Date(slotSchedule);

  if (isSelected) {
    props.color = colors.brand[500];
    props.backgroundColor = colors.blue[100];
  }

  if (today < startDate) {
    props.color = colors.orange[300];
    props.backgroundColor = colors.yellow[100];
    if (isSelected) {
      props.color = colors.brand[500];
      props.backgroundColor = colors.blue[100];
    }
    text = `Mulai ${format(startDate, "dd MMM yyyy")}`;
  }

  return <StyledChip {...props}>{text}</StyledChip>;
};

const SlotCard: React.FC<ISlotCardProps> = ({
  isSelected,
  isOptional,
  teacher,
  clashesWith,
  days,
  title,
  startTime,
  endTime,
  onSelectSlot,
  remainingSlots,
  startDate
}) => {
  const baseUrl = process.env.NEXT_PUBLIC_MEDIA_SESSIONS_URL;
  const getTeacherImage = (path: string) =>
    path && baseUrl ? `${baseUrl}/${path}` : DefaultPhotoProfile;

  const result = useFeature<ISlotSelectionUnavailableFeatureValue>(
    GrowthbookFeatures.slotSelectionUnavailableTeacherInfo
  );

  return (
    <SlotCardWrapper
      isSelected={isSelected}
      isDisabled={isOptional ? false : !!clashesWith}
      onClick={clashesWith ? noop : onSelectSlot}
    >
      <SlotInformationWrapper>
        <SlotScheduleWrapper>
          {isOptional && <SlotTitle>{title}</SlotTitle>}
          {!isOptional && (
            <>
              <SlotSchedule>
                {days} • {startTime} - {endTime} {getIndonesianTimezone()}
              </SlotSchedule>
              <SlotStartDateAndSeatContainer>
                {renderClassStatusChip(startDate, isSelected)}
                {renderAvailableSeatsChip(remainingSlots, isSelected)}
              </SlotStartDateAndSeatContainer>
            </>
          )}
        </SlotScheduleWrapper>
        {!isOptional && !clashesWith && (
          <>
            {teacher ? (
              <TeacherDetailWrapper>
                <TeacherImage
                  src={getTeacherImage(teacher.avatar_url)}
                  height={40}
                  width={40}
                  alt="teacher-image"
                  objectFit="cover"
                />
                <TeacherName>
                  {teacher.name}
                  <GuruJuaraBadge size={20} />
                </TeacherName>
              </TeacherDetailWrapper>
            ) : (
              <RequiredClassWrapper
                backgroundColor={
                  result.on
                    ? isSelected
                      ? colors.blue["100"]
                      : colors.yellow["50"]
                    : ""
                }
              >
                <InfoIcon
                  color={
                    result.on
                      ? isSelected
                        ? colors.brand["500"]
                        : colors.orange["300"]
                      : colors.brand["500"]
                  }
                  width="20"
                  height="20"
                />
                <RequiredClassText
                  color={
                    result.on
                      ? isSelected
                        ? colors.brand["500"]
                        : colors.orange["300"]
                      : ""
                  }
                >
                  {result.on
                    ? result.value?.message.id
                    : "Info guru menyusul, ya"}
                </RequiredClassText>
                <DateClassText
                  color={
                    result.on
                      ? isSelected
                        ? colors.brand["500"]
                        : colors.orange["300"]
                      : ""
                  }
                >
                  {result.value?.date_text.id}
                </DateClassText>
              </RequiredClassWrapper>
            )}
          </>
        )}
      </SlotInformationWrapper>
      {clashesWith ? (
        <ClashesWrapper>
          <InfoIcon color={colors.neutral["1000"]} width="13" height="13" />
          <ClashesText>Bentrok sama kelas {clashesWith}</ClashesText>
        </ClashesWrapper>
      ) : (
        <RadioButton
          id="slot-radio"
          checked={isSelected}
          onChange={() => null}
        />
      )}
    </SlotCardWrapper>
  );
};
export { SlotCard };
